import { debug } from "./debug-log";
import utils from "./utility";


//ProfAAdsIgnore currently only contains ads2_ignore logic for aspen articles pages and device based ignore ad positions functionality
function ProfAdsIgnore() {
  window.ads2_ignore = window.ads2_ignore || {};
  debug.log("[ibAds][ProfAdsIgnore] inside", window.ads2_ignore);
  //Always block 2122 ad until buiseness needs
  window.ads2_ignore["2122"] = true;

  if (typeof window.ads2_ignore !== "undefined") {
    setTimeout(() => {
      const ignore = window.ads2_ignore;
      if (ignore.all) {
        document.querySelectorAll('.AdUnit').forEach((adUnit) => adUnit.style.display = 'none');
      } else {
        const keyPOS = Object.keys(ignore);
        keyPOS.forEach((pos) => {
          if (ignore[pos] == "true" || ignore[pos]) {
            let adPosElement = document.getElementById(`ads-pos-${pos}`);
            if (adPosElement) {
              adPosElement.style.display = 'none';
            }
          }
        });
      }
    }, 1000);
  }


  if (PageMetadata.reqHeaders.device == 'MOBILE' || (utils.getBrkPnt() == '1' && PageMetadata.reqHeaders.device !== 'IPAD')) {
    window.ads2_ignore["101"] = true;
    window.ads2_ignore["420"] = true;
    window.ads2_ignore["421"] = true;
    window.ads2_ignore["520"] = true;
    window.ads2_ignore["910"] = true;
    window.ads2_ignore["122"] = true;
    window.ads2_ignore["127"] = true;
    window.ads2_ignore["141"] = true;
    window.ads2_ignore["142"] = true;
    window.ads2_ignore["104"] = true;
    window.ads2_ignore["970"] = true;
    window.ads2_ignore["971"] = true;
    window.ads2_ignore["145"] = true;
    window.ads2_ignore["909"] = true;
    window.ads2_ignore["800"] = true;
    window.ads2_ignore["918"] = true;
    window.ads2_ignore["919"] = true;
    window.ads2_ignore["309"] = true;
  } else if (PageMetadata.reqHeaders.device == 'PC' || PageMetadata.reqHeaders.device == 'IPAD') {
    window.ads2_ignore["1004"] = true;
    window.ads2_ignore["1005"] = true;
    window.ads2_ignore["1420"] = true;
    window.ads2_ignore["1421"] = true;
    window.ads2_ignore["1520"] = true;
    window.ads2_ignore["1122"] = true;
    window.ads2_ignore["2017"] = true;
    window.ads2_ignore["1522"] = true;
    window.ads2_ignore["1523"] = true;
    window.ads2_ignore["1712"] = true;
    window.ads2_ignore["1970"] = true;
    window.ads2_ignore["1971"] = true;
    window.ads2_ignore["1145"] = true;
    window.ads2_ignore["1909"] = true;
    window.ads2_ignore["1800"] = true;
    window.ads2_ignore["1523"] = true;
    window.ads2_ignore["1918"] = true;
    window.ads2_ignore["1919"] = true;
    window.ads2_ignore["1309"] = true;
  }

  if (window.pageCurrentURL.indexOf('viewcollection') != -1 && PageMetadata.reqHeaders.device == "MOBILE") {
    window.ads2_ignore["1005"] = true;
  }
  if (window.pageCurrentURL.indexOf('case-review') != -1 && PageMetadata.reqHeaders.device == "MOBILE") {
    window.ads2_ignore["1005"] = false;
  }
  if (PageMetadata && PageMetadata.pageSegVars && PageMetadata.pageSegVars.ctype === 20171) {
    if (PageMetadata.reqHeaders.device == "MOBILE" || utils.getBrkPnt() == "1") {
      window.ads2_ignore["309"] = true;
    } else {
      window.ads2_ignore["1309"] = true;
    }
  }
  if (PageMetadata.pageSegVars && PageMetadata.pageSegVars.ctype == '10511' && PageMetadata.reqHeaders.device == 'PC') {
    window.ads2_ignore["122"] = true;
    window.ads2_ignore["127"] = false;
  }
  if (PageMetadata.pageSegVars && PageMetadata.pageSegVars.ctype == "10511" && PageMetadata.reqHeaders.device == 'PC') {
    window.ads2_ignore["141"] = false;
  }
}

export default ProfAdsIgnore;
